module.exports = __webpack_public_path__ + "img/huang.d487ca26.png";